import { render, staticRenderFns } from "./StoperControls.vue?vue&type=template&id=60b02bb5&scoped=true&"
import script from "./StoperControls.vue?vue&type=script&lang=js&"
export * from "./StoperControls.vue?vue&type=script&lang=js&"
import style0 from "./StoperControls.vue?vue&type=style&index=0&id=60b02bb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b02bb5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60b02bb5')) {
      api.createRecord('60b02bb5', component.options)
    } else {
      api.reload('60b02bb5', component.options)
    }
    module.hot.accept("./StoperControls.vue?vue&type=template&id=60b02bb5&scoped=true&", function () {
      api.rerender('60b02bb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StoperControls.vue"
export default component.exports